import React, { Fragment } from "react";

const CompanyProfilePicture = () => {
  return (
    <Fragment>
      <div className="profile-picture-circle blue">
        <div className="profile-picture"></div>
      </div>
    </Fragment>
  );
};

export default CompanyProfilePicture;
